import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-3, arrow"><path d="M19.25 8.75L3.25 3.25L8.75 19.25L11.75 16.25L16.75 21.25L21.25 16.75L16.25 11.75L19.25 8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCursor3;
